import axios from 'axios';
import * as React from 'react';
import { requestCreateApTemplateAction } from '../asyncHelpers/actionPlanTemplateService';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import { ApTemplateAction, CreateApTemplateActionRequest } from '../sic-lib/types/ApTemplateAction';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

/**
 * useAsyncCreateApTemplateAction
 *
 * @description
 * React hook providing request state management and cancellation for the
 * requestCreateApTemplateAction HTTP request
 */
export default function useAsyncCreateApTemplateAction() {
    const request_token = axios.CancelToken.source();
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);

    const asyncCreateApTemplateAction = async (
        templateId: number,
        apAction: CreateApTemplateActionRequest,
    ): Promise<ApTemplateAction | undefined> => {
        try {
            setRequestStatus(RequestStatus.active);

            const { data } = await requestCreateApTemplateAction(
                templateId,
                apAction,
                request_token.token,
            );

            setRequestStatus(RequestStatus.success);

            return data;
        } catch (error: any) {
            if (!axios.isCancel(error)) {
                /* Notify user of failed http request */
                const toastData = createErrorToast('Error while creating Action Plan action');

                dispatch(createToast({ toastData }));

                /* Update state */
                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return {
        requestStatus,
        asyncCreateApTemplateAction,
    };
}
